import { openNotificationModal } from 'store/use-notification-modal-store';
import { NotificationType } from 'common/enums/enums';
import { EstateStatusDto } from 'common/enums/services/api/estates/estate-status-dto.enum';

type Arguments = {
  modalProps: {
    onClose?: () => void;
  };
};

const INCOMPLETE_LISTING_STATUSES = [
  EstateStatusDto.Incomplete,
];

const useListingCompletenessGuard = (listingStatus: EstateStatusDto | undefined, args?: Arguments) => {
  const isListingComplete = listingStatus ? !INCOMPLETE_LISTING_STATUSES.includes(listingStatus) : true;

  const openModal = () => {
    openNotificationModal({
      type: NotificationType.WARNING,
      title: 'Incomplete Listing',
      description: 'Please complete your listing details before confirming a tour. All required information must be filled out and the listing must be published.',
      onClose: args?.modalProps?.onClose,
    });
  };

  const withListingCompletenessGuard = (action: () => void) => {
    if (isListingComplete) {
      action();
    } else {
      openModal();
    }
  };

  return {
    withListingCompletenessGuard,
    isListingComplete,
  };
};

export { useListingCompletenessGuard };
